<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-body">
            <rsa-scheda-ospite-dimissione-trasferimento-component ref="cmpRsaTrasferimentoDimissioni" :jsonDataAccettazione="jsonData" :utente="utente" @beforeLoadData="showModalLoading = true" @afterLoadData="showModalLoading = false" />
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaSchedaOspiteDimissioneTrasferimentoComponent from "../../rsagestioneospiti/components/RsaSchedaOspiteDimissioneTrasferimentoComponent.vue";
export default {
    mixins: [UtilityMixin],
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaSchedaOspiteDimissioneTrasferimentoComponent,
    },
    data() {
        return {
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            filtro: {},
            btnNewVisible: true,
            pathResource: null,
            pathResourceAccettazione: "/rsaaccettazioni",
            linkedit: null,
            linkback: "/rsagestioneospiti",
            showModalLoading: false,
            listKey: 0,
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        me.loadAccettazione();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then(async (response) => {
                    me.jsonData = response.data.data;
                    await me.$nextTick();
                    me.$refs.cmpRsaTrasferimentoDimissioni.setId(me.idAccettazione);
                })
                .catch((error) => {
                    me.showModalLoading = false;
                    me.errorToast(error);
                });
        },
    },
};
</script>

<style></style>
